import { details } from './details';
import { root } from './registration';

export const registration = {
  ...root,
  details,
};
